import { createContext, useContext } from 'react';
import type { BoardPropsExtended } from '@magicyard/blanksy-game/src/Game';

const GameContext = createContext<BoardPropsExtended>(null as any);

export const useGameObject = () => useContext(GameContext);

export default GameContext;
